import { addModal } from 'weblite-web-modal-viewer'
import { RequestToJoinHallDialog } from './request-to-join-hall'

const COMPONENT_ID = 'requestToJoinHallDialog'

export const showRequestToJoinHallModal = (
  props: Omit<Parameters<typeof RequestToJoinHallDialog>[0], 'isOpen'>,
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: RequestToJoinHallDialog,
  },
}
